// @ts-check
import { th } from "intl-tel-input/i18n";
export class PageBuilder{
/**
 * 
 * @param {any} main 
 * @param {any} parent 
 */
constructor(main,parent){
this.m = this.main = main;//used when using this component to create another
this.parent = parent;
this.parent?.save?.bind(parent);

//this.pbInput = '';
this.isView = false;//enables contentEditable attribute to be set
this.init = true;
this.blockMargin  ="mb-3";
this.alignClasz = ['text-start','text-center','text-end'];
this.flexAlignClasz = ['justify-content-start','justify-content-center','justify-content-end'];
//
this.headingSizeClasz = ['fs-6','fs-4','fs-1'];
this.buttonSizeClasz = ['btn-sm','btn-md','btn-lg'];
//
this.baseProperties = [];//bgc,css,ec,pc
this.socialButtons = {
    facebook:'https://facebook.com',
    twitter:'https://x.com',
    linkedin:'https://linkedin.com',
    instagram:'https://instagram.com',
    youtube:'https://youtube.com',
    pinterest:'https://pinterest.com',
    snapchat:'https://snapchat.com',
    tiktok:'https://tiktok.com',
    reddit:'https://reddit.com',
    whatsapp:'https://whatsapp.com',
    telegram:'https://telegram.org'
};

this.selectionRange;//:Range;
this.selectedText;//:string;
this.initialText='God wants you well. Understanding and living according to God’s plan is the key to life’s fulfillment.';
this.ep={
//BLOCKS
heading:{
    data:{t:'Heading',ic:'',si:'md',sh:'0',al:'left'},
    alias:'Heading',
    type:'block',
    icon:'type-h1',
    func:'getHeadingBlock'
},

richText:{
    data:{t:this.initialText,al:'left'},
    alias:'Text',
    type:'block',
    icon:'alphabet-uppercase',
    func:'getRichTextBlock'
},

button:{
    data:{t:'Learn More',h:'',si:'md',ic:'',co:'primary',al:'left'},
    alias:'Button',
    type:'block',
    icon:'hand-index',
    func:'getButtonBlock'
},

table:{
    data:{al:'left'},
    alias:'Table',
    type:'block',
    icon:'table',
    func:'getTableBlock'
},

list:{
    data:{al:'left'},
    alias:'List',
    type:'block',
    icon:'card-list',
    func:'getListBlock'
},

form:{
    data:{al:'left'},
    alias:'Form',
    type:'block',
    icon:'postcard',
    func:'getFormBlock'
},

image:{
    data:{src:'',ht:'',wt:'',al:'left'},
    alias:'Image',
    type:'block',
    icon:'image',
    func:'getImageBlock'
},

social:{
    data:{al:'left'},
    alias:'Social',
    type:'block',
    icon:'facebook',
    func:'getSocialBlock'
},


//COMPONENTS
card:{
    data:{eh:'1',al:'left'},
    alias:'Card',
    type:'component',
    icon:'card-heading',
    func:'getCardComponent'
},

cover:{
    data:{al:'left'},
    alias:'Cover',
    type:'component',
    icon:'card-text',
    func:'getCoverComponent'
},
hero:{
    data:{al:'left'},
    alias:'Hero',
    type:'component',
    icon:'card-heading',
    func:'getHeroComponent'
},

cta:{
    data:{al:'left'},
    alias:'Call to action',
    type:'component',
    icon:'arrow-right-circle',
    func:'getCtaComponent'
},
faq:{
    data:{al:'left'},
    alias:'FAQ',
    type:'component',
    icon:'question-circle',
    func:'getFaqComponent'
},
subscribe:{
    data:{al:'left'},
    alias:'Subscribe',
    type:'component',
    icon:'envelope',
    func:'getSubscribeComponent'
},
//WIDGET
recentPosts:{
    data:{l:6,cat:-1,we:true,wi:true,wm:true,al:'left'},
    alias:'Recent posts widget',
    type:'widget',
    icon:'newspaper',
    func:'parent.widget.getRecentPostsWidget'
},
};



}//

/**
 * 
 * @param {string} type 
 * @returns 
 */
async getTemplate(type='new') {
//not used standalone but within other components
let $this = this;
this.pbComponent=this.main.pbu.createElement('main',['page-builder']);
this.pbComponent.innerHTML = 
`
<!--Header-->
<header class="pb-header my-4 d-flex justify-content-between bg-tertiary" style="width:90%;">
<div class="format-button-container" id="formatMenu">
<div class="btn-toolbar mb-3" role="toolbar" aria-label="Toolbar with button groups">
<div class="btn-group me-2" role="group">
<button name="spb" type="button" class="${this.m.pbu.showIf(!this.m.isMobile)} btn btn-outline-secondary btn-sm format-button"><i class="bi bi-type-bold"></i></button>
<button name="spi" type="button" class="${this.m.pbu.showIf(!this.m.isMobile)} btn btn-outline-secondary btn-sm  format-button"><i class="bi bi-type-italic"></i></button>
<button name="spu" type="button" class="${this.m.pbu.showIf(!this.m.isMobile)} btn btn-outline-secondary btn-sm  format-button"><i class="bi bi-type-underline"></i></button>
<button name="sps" type="button" class="${this.m.pbu.showIf(!this.m.isMobile)} btn btn-outline-secondary btn-sm  format-button"><i class="bi bi-type-strikethrough"></i></button>
<button name="spa" type="button" class="btn btn-outline-secondary btn-sm format-button"><i class="bi bi-link"></i></button>
</div>
</div>
</div>



<div role="group" id="pbMenu">

</div>

</header>
  <!--#Header-->
     
        <div id="pageBuilder">
        
         </div>
`;
this.pbMenu = this.pbComponent.querySelector('#pbMenu');
//this.addRowButton = this.pbComponent.querySelector('#addRowButton');
//
this.pageBuilder = this.pbComponent.querySelector('#pageBuilder');
//<footer class="pb-footer d-flex navbar sticky-bottom bg-light flex-md-nowrap p-0">
//<p></p>
 //</footer>
//this.saveButtonDiv = this.pbComponent.querySelector('div#saveButton');
//this.footer = this.pbComponent.querySelector('footer.pb-footer');
//this.parent.parent.footer.appendChild(this.main.tu.getSaveButton({component:this,cb:this.save,cbIsMain:true}));


let wrapper,blockContainer,container
if(type=='new'){
//set up and add focus to initial block
wrapper = await this.addRow(false);
blockContainer = wrapper.firstChild;// next sibling is block control
container = await this.createColumn(1,false,wrapper);
blockContainer.appendChild(container);
this.main.pbu.appendChild(container.querySelector('.sp-col'),await this.getRichTextBlock(),await this.getBlockMenu());
}else if(type=='edit'){
await this.initilizePageBuilder('edit');//edit section, there is also a preview/detail section
}
this.init = false;//??
addEvents();
return this.pbComponent;

async function addEvents(){
//<button id="addRowButton" type="button" class="btn btn-primary">Row<i class="bi bi-file-plus"></i></button>
$this.m.pbu.getEventButton('Row',{icon:'file-plus',cb:async()=>$this.addRow()}).then(b=>$this.m.pbu.replace($this.pbMenu,b));
//entry point
// $this.main.pbu.listen($this.addRowButton,'click',async ()=>{
// await $this.addRow();//
// },$this.parent);
//richtext format
let formatButtons = $this.pbComponent.querySelectorAll('button.format-button');
for(let b of formatButtons){
    $this.main.pbu.listen(b,'click',(e)=>{
        e.preventDefault();
        if(!$this.selectedText){return;}
        $this.formatText(b);
    },$this.parent,[...formatButtons]);
}//for
}//inner
}//func
/**
 * retrieves the serialized post content and setup the page builder
 * called from getTemplate for 'edit' only
 * @param {string} section if edit or detail, if edit, append the content to pagebuilder
 * if section is detail, return a response div
 */
async initilizePageBuilder(section){
let $this = this;
let n;//number of columns in each row
let isEdit = section=='edit';
//when returning 
let responseDiv = this.main.pbu.createElement('div');
//
let result = JSON.parse(this.pbInput);
for(let r of result.r){
n = r.n;
let wrapper, bc;
if(isEdit){
wrapper = await this.addRow(false);
bc = wrapper.firstElementChild;
this.main.pbu.appendChild(this.pageBuilder,wrapper);
}else{
    bc = responseDiv; 
}
let container = await this.createColumn(n,false,wrapper);
let row = container.querySelector('[n]');
let col1,col2,col3,col4;
if(n==1){
col1 =row.querySelector('.sp-col1');
await setMainElement(col1,r.c[0],'C1');
}else if(n==2){
col1 =row?.querySelector('.sp-col1');
col2 = row?.querySelector('.sp-col2');
await setMainElement(col1,r.c[0],'C1');
await setMainElement(col2,r.c[1],'C2');
}
else if(n==3){
col1 =row?.querySelector('.sp-col1');
col2 = row?.querySelector('.sp-col2');
col3 = row?.querySelector('.sp-col3');
//
await setMainElement(col1,r.c[0],'C1');
await setMainElement(col2,r.c[1],'C2');
await setMainElement(col3,r.c[2],'C3');
}else if(n==4){
col1 =row?.querySelector('.sp-col1');
col2 = row?.querySelector('.sp-col2');
col3 = row?.querySelector('.sp-col3');
col4 = row?.querySelector('.sp-col4');
//
await setMainElement(col1,r.c[0],'C1');
await setMainElement(col2,r.c[1],'C2');
await setMainElement(col3,r.c[2],'C3');
await setMainElement(col4,r.c[3],'C1');
}else if(n==5){
col1 =row?.querySelector('.sp-col1');
col2 = row?.querySelector('.sp-col2');
//
await setMainElement(col1,r.c[0],'C1');
await setMainElement(col2,r.c[1],'C2');
}else if(n==6){
col1 =row?.querySelector('.sp-col1');
col2 = row?.querySelector('.sp-col2');
//
await setMainElement(col1,r.c[0],'C1');
await setMainElement(col2,r.c[1],'C2');
}
this.main.pbu.appendChild(bc,container);
//set class on row
this.genFormatedClass(r,row,'r',false);
}
if(section=='detail'){
    return responseDiv;
}

//inner
/**
 * 
 * @param {HTMLDivElement} col 
 * @param  {any[]} dbCol 
 * @param  {string} columnLabel 
 */
async function setMainElement(col,dbCol,columnLabel){
let mains = dbCol.m;
for(let m of mains){
let bc;
let data = {
type:section,
v:m.v,
dClass:[]
};
switch(m.m){
//blocks
case 'heading':
if(data.v.text){
    data.v.t = data.v.text;
}
bc = await $this.getHeadingBlock(data);
break;
case 'button':
bc = await $this.getButtonBlock(data);
break;
case 'social':
bc = await $this.getSocialBlock(data);
break;
case 'richText':
if(data.v.text){
    data.v.t = data.v.text;
}
bc = await $this.getRichTextBlock(data);
break;
case 'table':
bc = await $this.getTableBlock(data);
break;
case 'list':
bc = await $this.getListBlock(data);
break;
case 'image':

//data.v.src = $this.main.media.getMediaUrl(data.v.s?data.v.s:data.v.src,true,false);
bc = await $this.getImageBlock(data);
break;
case 'audio':
data.v.src = $this.main.media.getMediaUrl(data.v.src,true,false);
bc = await $this.getAudioBlock(data);
break;
case 'video':
let isYoutube = data.v.src.includes('youtube.com') || data.v.src.includes('youtu.be');
if(!Youtube){
data.v.src = $this.main.media.getMediaUrl(data.v.src,true,false);
}
bc = await $this.getVideoBlock(data);
break;
case 'form':
if(data.v.titles){
    data.v.ts = data.v.titles;
}
bc = await $this.getFormBlock(data);
break;
//components :sp-component
case 'cover':
bc = await $this.getCoverComponent(data);
break;
case 'hero':
bc = await $this.getHeroComponent(data);
break;
case 'card':
bc = await $this.getCardComponent(data);
break;
case 'cta':
if(!data.v.heading){
    data.v.heading = {};
}
if(!data.v.body){
    data.v.body = {};
}
if(!data.v.button){
    data.v.button = {};
}
if(data.v.tt){
    data.v.heading.t = data.v.tt;
}
if(data.v.t){
    data.v.body.t = data.v.t;
}
if(data.v.bt){
    data.v.button.t = data.v.bt
}
if(data.v.bh){
    data.v.button.h = data.v.bh
}
bc = await $this.getCtaComponent(data);
break;
case 'faq':
bc = await $this.getFaqComponent(data);
break;
case 'subscribe':
bc = await $this.getSubscribeComponent(data);
break;
//widgets :sp-widget
case 'recentPosts':
//data.v = {l:6,cat:-1,we:true,wi:true,wm:true};
bc = await $this.parent.widget.getRecentPostsWidget(data);
    break;  
default:
    $this.main.log('no case match','PageBuilder.initilizePageBuilder.setMainElement()');
continue;
}
let main = bc.querySelector('[m]');
let parent = main.parentElement;
$this.genFormatedClass(m,main,'m',false);
let block;
if(isEdit){
block = bc;
}else{
block = parent;
$this.main.pbu.replaceClass(block,'col-11','col-12');
}
col.appendChild(block);
}//for
if(isEdit){
col.prepend(await $this.getBlockSettings(col,'c',columnLabel));
col.appendChild(await $this.getBlockMenu());
}
//finally
$this.genFormatedClass(dbCol,col,'c',false);
}//inner()
}//func

async save(){
let hasError = false;
let $this = this;
let result = {
    r:[]
};
let rows = this.pageBuilder.querySelectorAll('div[n]');//rows
for(let row of rows){
let r = {
n:this.main.pbu.getAttribute(row,'n'),
c:[]
};
this.genFormatedClass(row,r,'r',true);
result.r.push(r);

let cols = row.querySelectorAll('[c]');
for(let col of cols){
let c = {
    m:[]
};
this.genFormatedClass(col,c,'c',true);
r.c.push(c);
let els = col.querySelectorAll('[m]');
for(let el of els){
let name = this.main.pbu.getAttribute(el,'m');
let m = {
m:name,
v:null
};
this.genFormatedClass(el,m,'m',true);
await saveValue(m,el);

if(m.v){
c.m.push(m);
}
}//for blocks
}//for cols
}//divs

// if(hasError){
//     this.main.utils.finilizeSave(this);
//     return;
// }
let serial = JSON.stringify(result);
this.main.log(serial,'PageBuilder.save() - serialized object');
this.parent.save(serial);

/**
 * 
 * @param {any} m 
 * @param {HTMLElement} el 
 */
async function saveValue(m,el){
let button,image,element,src,text,href,icon,size,value;
//t=text;h=href;ic=icon;sh=sectionHeader;al=align;altt;alignTitleText;si=size;v=variant;s=source;ht=height;
/**
 * 
 * @param {string} name
 * @param {HTMLElement} element
 * @param {any} v  
 */
async function set(name,element=el,v=m.v){
    if(!element){return;}
    let props = Object.keys($this.ep[name]['data']);
    for(let prop of props){
        //temp:
        //bgc is handled separately
        if(prop=='bgc'){continue;}
        let value;
        if(prop=='t'){
            if(element.classList.contains('sp-rich-text')){
                value = element.innerHTML;
            }else{
                //eg button 
                value = element.querySelector('.sp-main-text').textContent
            }
            validate(element,value);
        }else if(prop=='src'){
        src = element.src;
        if(src && src!=$this.main.config.DEFAULT_PLACEHOLDER){
        value = src;
        }
        validate(element,value);
        }else if(prop=='ic'){
                icon = element.querySelector('svg.sp-svg') || element.querySelector('i.sp-svg')
                value = $this.main.pbu.getAttribute(icon,'ic');
        }else if(prop=='h'){
            value = $this.setHref(element);
        }else{
            value = $this.main.pbu.getAttribute(element,prop);
        }
        //NOTE: try to use 0 as defaults that could be ignored
        if(value){
            ///
            if(prop=='al'&&value=='left'){}
            else if(prop=='si'&&value=='md'){}
            else if(prop=='sh'&&value=='0'){}
            else if(prop=='eh'&&value=='0'){}//
            else if(prop=='ht'&&value=='default'){}
            else{
                v[prop] = value;
            }
            ///

            //dont set default properties
            // if(['al','si'].includes(prop)){
            //     value = value.toLocaleLowerCase();
            //     if(value=='left'||value=='md'){
            //         //do nothing
            //     }else{
            //         v[prop] = value;
            //     }
            // }else{
            //     v[prop] = value;
            // }
        }
        //finally
        
    }
}

switch(m.m){
case 'heading':
m.v ={
};
await set(m.m);
break;
case 'button':
m.v = {
};
await set(m.m);
break;
case 'social':
let buttons = [...el.querySelectorAll('.sp-social')];
if(buttons.length>0){
        let bs = [];
    for(let button of buttons){
        bs.push({
            h:$this.setHref(button),
            n:button.querySelector('.sp-main-text').textContent
        });
    }
            m.v = {
            bs:bs
            };
}
await set(m.m);
break;
case 'richText':
m.v={
};
await set(m.m);
break;
case 'table':
let trv = [];
let thv = [...el.querySelectorAll('.sp-th input')].map(i=>i.value);
let trs = el.querySelectorAll('.sp-tr');
for(let tr of trs){
    let trInputs  = [...tr.querySelectorAll('.sp-td div')].map(i=>i.innerHTML);
    trv.push(trInputs);
}
m.v={
thv:thv,
trv:trv
};
await set(m.m);
break;
case 'list':
let inputs = [...el.querySelectorAll('.sp-list div.sp-li')].map(i=>i.innerHTML);
m.v={
li:inputs
};
await set(m.m);
break;
case 'image':
//will validate
image = el;
if(image){
m.v = {

}
await set(m.m,image,m.v);//always for images
}
break;
case 'audio':
case 'video':
m.v={

};
break;
case 'form':
let titles = [];
let formTitle = el.querySelectorAll('.sp-form-title');
let messagePlaceholder = el.querySelector('textarea').value;
for(let t of formTitle){
let input = t.nextElementSibling;
let required = input.classList.contains('sp-validation-required');
titles.push({
t:t.textContent,/**Title */
r:$this.main.utils.getBit(required),/**required */
tp:input.type, /**type */
cp:input.value /**ControlPlaceholder */
});
}
m.v={
ts:titles,
mp:messagePlaceholder//message placeholder
};
await set(m.m);
break;
// ############## components :sp-component ###############
case 'cover':
button = el.querySelectorAll('.sp-button');//max = 2
m.v = {
heading:{},
body:{},
button1:{}  
};
await set('heading',el.querySelector('.sp-h'),m.v.heading);
await set('richText',el.querySelector('.sp-rich-text'),m.v.body);
await set('button',button[0],m.v.button1);
//must have at least one button
if(button.length==2){
m.v.button2 = {};
await set('button',button[1],m.v.button2);
}
//image is optional
image = el.querySelector('img.main-media');
if(image?.src){
m.v.image = {};
await set('image',image,m.v.image);//always for images
}
await set(m.m);
break;
case 'hero':
//all fields required
m.v = {
heading:{},
body:{},
button:{},
image:{}  
};
await set('heading',el.querySelector('.sp-h'),m.v.heading);
await set('richText',el.querySelector('.sp-rich-text'),m.v.body);
await set('button',el.querySelector('.sp-button'),m.v.button);
await set('image',el.querySelector('img.main-media'),m.v.image);
await set(m.m);
break;
case 'card':
//HEADING IS USED FOR TITLE
m.v = {
heading:{},
};
await set('heading',el.querySelector('.sp-h'),m.v.heading);
//OPTIONAL PROPERTIES
image = el.querySelector('img.main-media');
if(image?.src){
m.v.image = {};
//NOTE: for image, must pass el as, media div is used in ulploadToServer()
await set('image',image,m.v.image);
}
//
element = el.querySelector('.sp-rich-text');//BODY
if(element){
m.v.body = {};
await set('richText',element,m.v.body);
}

///// BUTTON
//optional
button = el.querySelector('.sp-button');
if(button){
    m.v.button = {};
    await set('button',button,m.v.button);//single button for card and its optional
}
await set(m.m);
break;
case 'cta':
m.v = {
heading:{},
body:{},
button:{}
};
await set('heading',el.querySelector('.sp-h'),m.v.heading);
await set('richText',el.querySelector('.sp-rich-text'),m.v.body);
await set('button',el.querySelector('.sp-button'),m.v.button);
await set(m.m);
break;
case 'faq':
let questions = el.querySelectorAll('.sp-faq-question');
let answers = el.querySelectorAll('.sp-faq-answer');
let qas = [];
for(let i=0;i<questions.length;i++){
    qas.push({
        q:questions[i].textContent,
        a:answers[i].innerHTML
    });
}
m.v={
heading:{},
qas:qas
};
set('heading',el.querySelector('.sp-h'),m.v.heading);
await set(m.m);
break;
case 'subscribe':
m.v = {
heading:{},
button:{}
};
await set(m.m);
await set('heading',el.querySelector('.sp-h.sp-subscribe-heading'),m.v.heading);
await set('button',el.querySelector('.sp-button'),m.v.button);
//optional => body
element = el.querySelector('.sp-rich-text.sp-subscribe-body');
if(element){
    m.v.body = {};
    await set('richText',element,m.v.body);
}
break;
// ############## widgets :sp-widget ###############
case 'recentPosts':
m.v={
};
await set(m.m);
break;
}//switch
}//inner

/**
 * 
 * @param {HTMLElement} element 
 * @param {string} value 
 */
async function validate(element,value) {
    if(element.classList.contains('sp-required')){
                if(!value || value=='<br>'){
                    $this.main.pbu.addClass(element,['border','border-danger']);
                    hasError = true;
                }
            }
}//inner
}//func


/**
 * 
 * @param {string} name 
 * @param {HTMLElement} el 
 * @param {any} v 
 */
async restoreAttributes(name,el,v){
let non = ['t','src','h','ic'];
let properties = Object.keys(this.ep[name]['data']);
for(let prop of properties){
    //ignore text and src as they are not set on elements
    if(non.includes(prop)){continue;}
    if(v[prop]){
        el.setAttribute(prop,v[prop]);
    }
}
}//func
/**
 * 
 * @param {HTMLButtonElement|HTMLAnchorElement} b 
 * @returns 
 */
setHref(b){
if(!b) {return '';}
if(!b.href){return '';}
//check 
let href = b.href;
if(href==window.location.href){return '';}
let u = new URL(href);
if(u.hostname=='localhost'){
    return u.pathname;
}else{
    return u.href;
}
}//func
/**
 * 
 * @param {HTMLElement} el 
 * @param {string} type 
 */
setHr(el,type){
let parent = el.closest('[p]');
let isColumn = type=='c';
let isEl = type=='m';
let sp = this.main.pbu.getAttribute(el,'sp');
let hr = null;
if(sp){
//remove space
if(isEl){
hr = parent.lastElementChild;
}else if(isColumn){
hr = el.lastElementChild;
}else{
hr = el.nextElementSibling;
}
hr?.remove();
el.removeAttribute('sp');
}else{
//add space
el.setAttribute('sp','true');
hr = this.main.pbu.createHr();
if(isEl){
parent.appendChild(hr);
}else if(isColumn){
el.appendChild(hr);
}else{
el.after(hr);
}

}
}//func
/**
 * 
 * @param {HTMLInputElement} cssControl 
 * @param {HTMLElement} el 
 */
setCss(cssControl,el){
if(!this.main.vu.validate(cssControl)){return;}
let oldCss = el.getAttribute('css');
let css;
let value = cssControl.value;//string
//saved as a string separated by space
this.m.pbu.removeClass(el,oldCss?.split(' '));
if(value){
css = value.trim().replaceAll(',',' ');
    //they entered new values or updating
this.m.pbu.addClass(el,css.split(' '));
//array
}else{
//nothing supplied, probably removing current classes
css = '';
}
//always
if(css){
el.setAttribute('css',css);
}else{
el.removeAttribute('css');  
}
}//func

/**
 * 
 * @param {HTMLElement|any} source 
 * @param {HTMLElement|any} recipient 
 * @param {string} type
 * @param {boolean} save 
 */
genFormatedClass(source,recipient,type,save=false){
let bgc,css,sp,ec,pc;
if(save){
    //these are all set on the main element
bgc = this.main.pbu.getAttribute(source,'bgc');//background clolor
css = this.main.pbu.getAttribute(source,'css');//custom class
sp = this.main.pbu.getAttribute(source,'sp');//space
if(bgc){recipient.bgc = bgc;}
if(css){recipient.css = css;}
if(sp){recipient.sp = 1;}

}else{
    //not saving
    if(source.bgc){
        recipient.setAttribute('bgc',source.bgc);
    }
    if(source.css){
        recipient.setAttribute('css',source.css);
        this.main.pbu.addClass(recipient,source.css.split(' '));
    }
    if(source.sp){
        this.setHr(recipient,type);
    }
}
}//func

/**
 * 
 * @param {number} n 
 * @param {boolean} withMenu
 * @param {HTMLElement} wrapper
 * @returns {HTMLElement}
 */
async createColumn(n,withMenu=true,wrapper){
let col1,col2,col3,col4;
let container = this.main.pbu.createElement('div',['container-fluid','sp-container',this.blockMargin]);
container.setAttribute('d','d');//just for ref
let row = this.main.pbu.createElement('div',['row','sp-row','g-2']);
row.setAttribute('n',n);
container.appendChild(row);//    
if(n==1){
col1 = this.main.pbu.createElement('div',['col-12','sp-col','sp-col1']);
row.appendChild(col1);//
}else if(n==2){
col1 = this.main.pbu.createElement('div',['col-md-6','sp-col','sp-col1']);
col2 = this.main.pbu.createElement('div',['col-md-6','sp-col','sp-col2']);
this.main.pbu.appendChild(row,col1,col2);
}
else if(n==3){
col1 = this.main.pbu.createElement('div',['col-md-4','sp-col','sp-col1']);
col2 = this.main.pbu.createElement('div',['col-md-4','sp-col','sp-col2']);
col3 = this.main.pbu.createElement('div',['col-md-4','sp-col','sp-col3']);
this.main.pbu.appendChild(row,col1,col2,col3);
}else if(n==4){
col1 = this.main.pbu.createElement('div',['col-md-3','sp-col','sp-col1']);
col2 = this.main.pbu.createElement('div',['col-md-3','sp-col','sp-col2']);
col3 = this.main.pbu.createElement('div',['col-md-3','sp-col','sp-col3']);
col4 = this.main.pbu.createElement('div',['col-md-3','sp-col','sp-col4']);
this.main.pbu.appendChild(row,col1,col2,col3,col4);
}else if(n==5){
col1 = this.main.pbu.createElement('div',['col-md-4','sp-col','sp-col1']);
col2 = this.main.pbu.createElement('div',['col-md-8','sp-col','sp-col2']);
this.main.pbu.appendChild(row,col1,col2);
}
else if(n==6){
col1 = this.main.pbu.createElement('div',['col-md-8','sp-col','sp-col1']);
col2 = this.main.pbu.createElement('div',['col-md-4','sp-col','sp-col2']);
this.main.pbu.appendChild(row,col1,col2);
}
col1?.setAttribute('c','c');
col2?.setAttribute('c','c');
col3?.setAttribute('c','c');
col4?.setAttribute('c','c');
if(withMenu){
//append the blockMenu to enable block section

col1?.append(await this.getBlockSettings(col1,'c','C1'),await this.getBlockMenu());
col2?.append(await this.getBlockSettings(col2,'c','C2'),await this.getBlockMenu());
col3?.append(await this.getBlockSettings(col3,'c','C3'),await this.getBlockMenu());
col4?.append(await this.getBlockSettings(col4,'c','C4'),await this.getBlockMenu());
}

if(!this.isView){
let handle = wrapper.querySelector('.sp-block-container-handle');
handle.appendChild(await this.getBlockSettings(row,'r'));
}


return container;

}//func

/**
 * 
 * @param {boolean} withMenu 
 * @returns 
 */
async addRow(withMenu=true){
let wrapper = this.main.pbu.createElement('div',['row','sp-wrapper','position-relative',this.blockMargin]);
//for element to create
let blockContainer = this.main.pbu.createElement('div',['col-11','sp-block-container','border','border-primary-subtle']);//??
wrapper.appendChild(blockContainer);
let handle = this.main.pbu.createElement('div',['col-1','sp-block-container-handle']);
handle.style.minHeight = '50vh';
//append to wrapper
this.main.pbu.appendChild(wrapper,blockContainer,handle);
//############

//needed for click to select columns
if(!this.m.isMobile){
this.main.pbu.appendChild(this.pageBuilder,wrapper);
}


//No temp selection menu needed in 'edit'
if(withMenu){
//c3
let columnsDiv = this.main.pbu.createElement('div',['h-100','d-flex','justify-content-center','align-items-center']);
columnsDiv.innerHTML =
`
<div class="pbr-parent container d-flex justify-content-evenly h-50 ${this.main.pbu.addClassIf(this.m.isMobile,['flex-column','flex-row'])}" style="cursor:pointer;">
<!-- 100% -->
  <div class="pbr-child d-flex justify-content-evenly p-2 mb-2 h-50" nn="1" style="width:16%;border: 1px solid gray;">
  <div class="pbr-gchild w-100" style="border: 1px dashed gray;"></div>
  </div>

  <!-- 50:50 -->
  <div class="pbr-child d-flex justify-content-evenly p-2 mb-2 h-50" nn="2" style="width:16%;border: 1px solid gray;">
  <div class="pbr-gchild w-50" style="border: 1px dashed gray;"></div>
  <div class="pbr-gchild w-50" style="border: 1px dashed gray;"></div>
  </div>

<!-- 33:33:33 -->
  <div class="pbr-child d-flex justify-content-evenly p-2 mb-2 h-50" nn="3" style="width:16%;border: 1px solid gray;">
  <div class="pbr-gchild" style="border: 1px dashed gray;width: 33.3%;"></div>
  <div class="pbr-gchild" style="border: 1px dashed gray;width: 33.3%;"></div>
  <div class="pbr-gchild" style="border: 1px dashed gray;width: 33.3%;"></div>
  </div>

<!-- 25:25:25:25 -->
  <div class="pbr-child d-flex justify-content-evenly p-2 mb-2 h-50" nn="4" style="width:16%;border: 1px solid gray;">
  <div class="pbr-gchild w-25" style="border: 1px dashed gray;"></div>
  <div class="pbr-gchild w-25" style="border: 1px dashed gray;"></div>
  <div class="pbr-gchild w-25" style="border: 1px dashed gray;"></div>
  <div class="pbr-gchild w-25" style="border: 1px dashed gray;"></div>
  </div>

<!-- 25:75 -->
  <div class="pbr-child d-flex justify-content-evenly p-2 mb-2 h-50" nn="5" style="width:16%;border: 1px solid gray;">
  <div class="pbr-gchild w-25" style="border: 1px dashed gray;"></div>
  <div class="pbr-gchild w-75" style="border: 1px dashed gray;"></div>
  </div>

<!-- 75:25 -->
  <div class="pbr-child d-flex justify-content-evenly p-2 mb-2 h-50" nn="6" style="width:16%;border: 1px solid gray;">
  <div class="pbr-gchild w-75" style="border: 1px dashed gray;"></div>
  <div class="pbr-gchild w-25" style="border: 1px dashed gray;"></div>
  </div>
</div>

`;
 
let cs = columnsDiv.querySelectorAll('.pbr-child');
let n;
for(let c of cs){
this.main.pbu.listen(c,'click',async ()=>{
n = this.main.pbu.getAttribute(c,'nn');
if(this.m.isMobile){
//not previously appended
this.main.pbu.appendChild(this.pageBuilder,wrapper);
blockContainer.appendChild(await this.createColumn(n,true,wrapper));
this.m.offCanvas.close();
}else{
blockContainer.replaceChild(await this.createColumn(n,true,wrapper),columnsDiv);
}

});
}
//now
if(!this.m.isMobile){
blockContainer.appendChild(columnsDiv);
}else{
    let ul = this.m.pbu.createElement('ul',['list-unstyled']);
    for(let c of cs){
        ul.appendChild(c);
        c.style.width = '80%';
        c.style.height= '16vh';
        this.m.pbu.removeClass(c,['h-50']);
    }
    //setOffCanvas
    this.m.offCanvas = this.main.utils.setOffCanvas('Select number of columns',ul);
    //this.m.modal = this.main.utils.setModal('Select number of columns',ul,false,{withAction:false});
}

}
//######### section to delete and move block #########


if(!withMenu){
return wrapper;
}

}//func



/**
 * 
 * @param {HTMLElement} wrapper 
 * @param {string} type 
 @param {string} title
 * @returns 
 */
async getBlockSettings(wrapper,type,title=''){
let isRow = type=='r';
let isColumn = type=='c';
let isEl = type=='m';
let targetEl = wrapper;//just for ref, where the class is actually applied
let parent;
if(isEl){
    //here wrapper = blockContainer;
    targetEl = wrapper.querySelector('[m]');
    parent  =  wrapper.querySelector('[p]');
}

let div = this.main.pbu.createElement('div');
div.innerHTML = 
`
<div class="${this.main.pbu.addClassIf(isRow,['btn-group-vertical','sp-button-group','p-0'])}">
    <button name="remove" type="button" class="btn btn-sm btn-outline-secondary">${await this.main.pbu.getSvg('x-square')}</button>
    <button name="moveUp" type="button" class="btn btn-sm btn-outline-secondary ${this.main.pbu.showIf(! isColumn)}">${await this.main.pbu.getSvg('arrow-up-square')}</button>
    <button name="moveDown" type="button" class="btn btn-sm btn-outline-secondary ${this.main.pbu.showIf(! isColumn)}">${await this.main.pbu.getSvg('arrow-down-square')}</button>
    <button name="spacer" type="button" class="btn btn-sm btn-outline-secondary">${await this.main.pbu.getSvg('distribute-vertical')}</button>
</div>
`;
this.m.pbu.prependChild(div.firstElementChild,
await this.main.pbu.getDropdown({el:targetEl,icon:'paint-bucket',attr:'bgc',size:'sm',clasz:['d-inline'],items:['None','Default','Theme'],defaultValue:'None'}),
`<p class="text-center ${this.main.pbu.showIf(isColumn)}">${title}</p>`);

let buttons = div.querySelectorAll('[name]');
let name;
for(let button of buttons){
    this.main.pbu.listen(button,'click',()=>{
    name = this.main.pbu.getAttribute(button,"name");
        switch(name){
                    case "remove":
                        if(isEl){
                            wrapper.remove();
                        }else if(isColumn){
                            let bcs = targetEl.querySelectorAll('.sp-bc');
                            for(let bc of bcs){
                                bc.remove();
                            }
                        }else if(isRow){
                            targetEl.closest('.sp-wrapper').remove();
                        }
                        
                        break;
                    case "moveUp":
                        if(isEl){
                            this.moveBlock(wrapper,'up');
                        }else if(isColumn){

                        }else if(isRow){
                            this.moveBlock(targetEl.closest('.sp-wrapper'),'up');
                        }
                        
                        break;
                    case "moveDown":
                        if(isEl){
                            this.moveBlock(wrapper,'down');
                        }else if(isColumn){

                        }else if(isRow){
                            this.moveBlock(targetEl.closest('.sp-wrapper'),'down');
                        }
                        
                        break;
                    case "spacer":
                        this.setHr(targetEl,type);
                            break;
                        
        }

    });
}//for
return div;
}//func

async getBlockMenu2(){
//called within each column of the initially added row
let dropDown = this.main.pbu.createElement('div',['dropdown','sp-dropdown','position-relative']);
dropDown.innerHTML = 
`
  <button class="btn btn-sm btn-primary dropdown-toggle no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i class="bi bi-file-plus"></i></button>
    <ul class="dropdown-menu position-absolute" style="z-index:1050;">
    <li>
      <div class="row">
      <div class="col-3"><button action="getButtonBlock" block-type="block" class="dropdown-item" type="button">Button</button></div>
      <div class="col-3"><button action="getHeadingBlock" block-type="block" class="dropdown-item" type="button">Heading</button></div>
      <div class="col-3"><button action="getRichTextBlock" block-type="block" class="dropdown-item" type="button">Rich Text</button></div>
      <div class="col-3"><button action="getFormBlock" block-type="block" class="dropdown-item" type="button">Form</button></div>
    </div>
    </li>

    <li>
      <div class="row">
      <div class="col-3"><button action="getTableBlock" block-type="block" data-variant="normal" class="dropdown-item" type="button">Table</button></div>
      <div class="col-3"><button action="getListBlock" block-type="block" class="dropdown-item" type="button">List</button></div>
      <div class="col-3"><button action="getSubscribeComponent" block-type="component" class="dropdown-item" type="button">Subscribe</button></div>
      <div class="col-3"><button action="getImageBlock" block-type="block" class="dropdown-item" type="button">Image</button></div>
    </div>
    </li>

    <li>
      <div class="row">
      <div class="col-3"><button action="getAudioBlock" block-type="block"  class="dropdown-item" type="button">Audio</button></div>
      <div class="col-3"><button action="getVideoBlock" block-type="block"  class="dropdown-item" type="button">Video</button></div>
      <div class="col-3"><button action="getCoverComponent" block-type="component"  class="dropdown-item" type="button">Cover</button></div>
    <div class="col-3"><button action="getHeroComponent" block-type="component"  class="dropdown-item" type="button">Hero</button></div>
    </div>
    </li>

    <li>
      <div class="row">
      <div class="col-3"><button action="getCardComponent" block-type="component" class="dropdown-item" type="button">Card</button></div>
      <div class="col-3"><button action="getCtaComponent" block-type="component" class="dropdown-item" type="button">Call To Action</button></div>
      <div class="col-3"><button action="getFaqComponent" block-type="component" class="dropdown-item" type="button">FAQ</button></div>
     <div class="col-3"><button action="getSocialBlock" block-type="block"  class="dropdown-item" type="button">Social</button></div>
    </div>
    </li>

    <li>
      <div class="row">
            <div class="col-3"><button action="getRecentPostsWidget" block-type="widget" class="dropdown-item" type="button">Recent Posts</button></div>
    </div>
    </li>

  </ul>
`;
let dropdownItems = dropDown.querySelectorAll('.dropdown-item');
for(let di of dropdownItems){
this.main.pbu.listen(di,'click',async ()=>{
    let action = this.main.pbu.getAttribute(di,'action');
    let blockType = this.main.pbu.getAttribute(di,'block-type');
    let variant = this.main.pbu.getAttribute(di,'data-variant');
    let block;
    if(blockType=='widget'){
        block = await this.parent.widget[action]();
    }else{
        //temp solution
        //check if its write pad in beta is  used 
        if(variant && action=='getTableBlock'){
            block = await this[action]({type:'new',v:{variant:variant},dClass:[]}); 
        }else{
            block = await this[action](); 
        }
          
    }
    dropDown.before(block);
    
});//#listen
}
return dropDown;
}//func

async getBlockMenu(){
//called within each column of the initially added row
let container = this.m.pbu.createElement('div',['container']);
container.innerHTML = 
`
<div class="row sp-row" style="cursor:pointer;">

</div>
`;
///
let dropDown = await this.m.pbu.getEventButton('Add',{icon:'file-plus',cb:()=>{
    this.m.offCanvas = this.m.utils.setOffCanvas('',container,{placement:'bottom',height:(this.m.isMobile)?'100vh':'80vh'});
}});
///
let row = container.querySelector('div.sp-row');
let blocks = Object.entries(this.ep);
let name,value;
for(let b of blocks){
name = b[0];
value =b[1];
this.m.pbu.appendChild(row,
    await this.m.pbu.ce(
        ['div',['col-md-2','col-sm-6','sp-item'],'',[{n:'data-name',v:name}]],
        ['h5',['text-center','mb-0'],value.alias],
        ['h3',['text-center'],'',[{n:'ic',v:{name:value.icon,data:{width:'100',height:'100',clasz:['sp-primary']}}}]])
);
}

let itemDivs = [...container.querySelectorAll('div.sp-item')];
for(let itemDiv of itemDivs){
this.main.pbu.listen(itemDiv,'click',async ()=>{
    name = this.main.pbu.getAttribute(itemDiv,'data-name');
    let func = this.ep[name]['func'];
    let block;
    if(name=='recentPosts'){
        block = await this.parent.widget.getRecentPostsWidget();
    }else{
        block = await this[func]();
    }

    dropDown.before(block);
    this.m.offCanvas.close();
});//#listen
}
return dropDown;
}//func

/**
 * 
 * @param {any} data
 * @returns 
 */
async getBlockContainer(data ={name:'',main:'div',clasz:[]}){
let $this = this;
//dont add buttom margin to children to avoid double spacing
let blockContainer = this.main.pbu.createElement('div',['sp-bc',(data.parent)?'sp-component-child':this.blockMargin,'container-fluid']);
let row =
`
<div class="row position-relative">
<div class="col-1 sp-col-1" contenteditable="false" width = "1px">
    <div class="position-absolute block-settings" style="top: 0px;left: 5px;">
    <button name="${data.name}" type="button" class="btn sp-cm"><i name="${data.name}" class="bi bi-three-dots-vertical"></i></button>
    </div>
</div>
    <div p="${data.name}-parent" class="col-11">
    
    </div>
  </div>
`;
this.main.pbu.appendChild(blockContainer,row);
let col1 = blockContainer.querySelector('.sp-col-1');
let cm = blockContainer.querySelector('.sp-cm');
let parentElement = blockContainer.querySelector('[p]');
this.main.pbu.appendChild(parentElement,typeof(data.main)=='string'?`<${data.main} class="main-element" m="${data.name}"></${data.main}>`:data.main);
let mainElement = blockContainer.querySelector('[m]');
this.main.pbu.addClass(mainElement,[this.blockMargin,'p-2',...data.clasz]);
if(data.parentClasz){
    this.main.pbu.addClass(parentElement,data.parentClasz);
}
if(data.parent){
    //main element will be the parent
    //avoid multiple selection or query when saving
    mainElement.removeAttribute('m');
}
//
if(this.isView || data.isWidget){
   mainElement.contentEditable = false;
   parentElement.contentEditable = false;
   return {bc:blockContainer,el:mainElement,parent:parentElement};
}else{
    ///########## GENERAL SETTINGS ###########
let cmSettings = this.main.pbu.createElement('div');
cmSettings.innerHTML =
`
<div id="cmSettings" class="my-2">

  <section class="block-settings my-1"></section>

  <section class="css ${this.main.pbu.showIf(this.m.isRoot)}">
  <p>Css (Separate by space or comma)</p>
  <div class="sp-form-control css">
    <input type="text" class="css form-control  my-2" placeholder="Custom class"/>
    </div>
  </section>

<section class="general-settings my-1 d-flex"></section>
<section class="other-settings"><section>
<div>
`;
let blockSettings = cmSettings.querySelector('section.block-settings');
let generalSettings = cmSettings.querySelector('section.general-settings');
let otherSettings = cmSettings.querySelector('section.other-settings');
let cssControl = cmSettings.querySelector('input.css');
this.main.pbu.replace(blockSettings,await this.getBlockSettings(blockContainer,'m'));
//align
let alignSettings = await this.main.pbu.getDropdown({name:"Align",el:mainElement,attr:'al',items:['Left','Center','Right'],defaultValue:'Left'});
this.m.pbu.appendChild(generalSettings,alignSettings);
//size
if(data.name=='heading'||data.name=='button'){
let sizeSettings = await $this.main.pbu.getDropdown({name:'Size',el:mainElement,attr:'si',items:['sm','md','lg']});
let iconSettings = await $this.main.pbu.getIcons({el:mainElement});
this.m.pbu.appendChild(generalSettings,sizeSettings,iconSettings);
}
//
let cMenu = {
blockSettings:blockSettings,
generalSettings:generalSettings,
otherSettings:otherSettings,
};



//events
this.main.pbu.listen(cm,'click',async()=>{
let template = await data.cmCallback(false);
if(template){
    this.main.pbu.replace(otherSettings,template);
}
let css = this.m.pbu.getAttribute(mainElement,'css')||'';
cssControl.value = css;
this.m.modal = this.main.utils.setModal(`${data.name} settings`,cmSettings);
this.main.pbu.listen(this.m.modal.confirm,'click',async ()=>{
   let saved = await data.cmCallback(true);
   if(saved){
    this.setCss(cssControl,mainElement);
    this.m.modal.dismiss.click();
   }
    
});
});
return {bc:blockContainer,el:mainElement,parent:parentElement,cMenu:cMenu};
}
}//func

//########### BASIC BLOCKS ##########
/**
 * 
 * @param {any} data
 * @returns {HTMLElement}
 */
async getHeadingBlock(data={}){
let {type='new',parent=null,v=this.ep.heading.data,dClass=[]} = data;
v = {...this.ep.heading.data,...v};
//{t:'Heading',ic:'',si:'md',sh:'0',al:'left'};
//temp: sass has not been implemented
//'fs-6','fs-4','fs-1'
let size = 'fs-4';//medium = default
if(v.si=='sm'){
    size = 'fs-6';
}else if(v.si=='md'){
    size = 'fs-4';
}else if(v.si=='lg'){
    size = 'fs-1';
}
let $this = this;
let elClass = ['sp-block','sp-heading',size, 'gap-2','sp-h',...dClass];
let r = await this.getBlockContainer({name:'heading',main:'h3',parent:parent,clasz:elClass,cmCallback:attachEvents});
r.el.innerHTML = 
`
${await this.main.pbu.getSvg(v.ic)}
<span class="d-inline-block sp-main-text" ${this.main.pbu.setAttributeIf(!this.isView,[{n:"contenteditable",v:"plaintext-only"}])}>${v.t}</span>
`
;
this.restoreAttributes('heading',r.el,v);
if(this.isView){
}else{
attachEvents(null);
}
//finally
return (this.isView && parent)? r.el: r.bc;
///
/**
 * 
 * @param {boolean|null} save 
 */
async function attachEvents(save){
if(save==null){
let isSectionHeader = $this.main.pbu.createCheckedInputElement({value:v.sh,isBool:true,el:r.el,attr:'sh',items:['Section Header?']});
$this.m.pbu.appendChildIf(r.cMenu.otherSettings,isSectionHeader);
}else if(save==false){

}else if(save==true){
    return true;
}
}//inner()

}//func


/**
 * 
 * @param {any} data 
 * @returns {HTMLElement}
 */
async getButtonBlock(data={}){
let $this = this;
let {type='new',parent=null,v=this.ep.button.data,isSocial=false,dClass=[],cb=null} = data;
v = {...this.ep.button.data,...v};
let elClass = ['sp-block','sp-button','text-center','btn',`btn-${v.si}`,`btn-${v.co}`,...dClass];
let r = await this.getBlockContainer({name:'button',main:'a',parent:parent,clasz:elClass,cmCallback:attachEvents});
r.el.innerHTML = 
  `
  ${await this.main.pbu.getSvg(v.ic)}<span class="sp-main-text">${this.main.utils.capitalize(v.t)}</span><i class="bi bi-link ms-2 d-none"></i>
  `;
r.el.type = 'button';
  //<a type="button" ${this.main.pbu.setAttributeIf(si!='md',[{n:"si",v:si}])} ${this.main.pbu.setAttributeIf(al!='left',[{n:"al",v:al}])} ${this.main.pbu.setAttributeIf(h,[{n:"href",v:h}])}  class="sp-button d-flex align-items-center btn btn-${si} btn-${color}">
  let buttonText = r.el.querySelector('span.sp-main-text');
  //when link is set
  let linkIcon = r.el.querySelector('i.bi-link');
r.el.href = (v.h)?v.h:'';
this.restoreAttributes('button',r.el,v);
if(this.m.isView){
}else{
    if(v.h){
     this.m.pbu.show(linkIcon);
    }
attachEvents(null);
  }
  return (this.m.isView && parent)? r.el: r.bc;
/**
 * 
 * @param {boolean|null} save 
 */
async function attachEvents(save){
let titleControl,linkControl;
if(save==null){
let settingsTemplate = $this.m.pbu.createElement('div');
  settingsTemplate.innerHTML = 
  `
  <div class="sp-basic-settings d-flex"></div>
  <form class="search-post auto-complete position-relative">
  <p>Link</p>
  ${$this.m.pbu.createFormControl({serialize:true,placeholder:"Title",value:`${r.el.querySelector('span.sp-main-text').textContent}`,clasz:['sp-title','sp-validation-required']})}
   ${$this.m.pbu.createFormControl({serialize:true,type:"url",placeholder:"Link",value:`${r.el.href}`,clasz:['sp-link']})}
   <ul class="list-group mt-2 search-post-display position-absolute" style="z-index:1050;cursor:pointer;">
  </ul>
  </form>
  `;

titleControl = settingsTemplate.querySelector('.sp-title');
linkControl = settingsTemplate.querySelector('.sp-link');
    if(isSocial){
      $this.m.pbu.hide(titleControl);
    }

     $this.main.pbu.listen(linkControl,'input',async()=>{
      //preprocess
    if(!$this.m.vu.sanitize([linkControl])){return;}//??
    let regex = new RegExp(`${linkControl.value}`, "i");
    let posts = await $this.m.fu.fetch({link:$this.main.fu.getApi('/home/posts',[{n:'limit',v:-1}])});
    posts = posts.filter(p=>regex.test(p.title));
    $this.main.autoComplete(linkControl,false,posts,'post');
  });//
$this.m.pbu.appendChild(r.cMenu.otherSettings,settingsTemplate);
}else if(save==false){


}else if(save==true){
    //otherSettings
titleControl = r.cMenu.otherSettings.querySelector('.sp-title');
linkControl = r.cMenu.otherSettings.querySelector('.sp-link');
if(!$this.m.vu.validate(titleControl,linkControl)){
        return;
      }
      buttonText.textContent = titleControl.value;
      if(linkControl.value){
        r.el.href = linkControl.value;
        $this.m.pbu.show(linkIcon);
        $this.m.pbu.addClass(r.el,['sp-route-link','sp-detail']);
      }else{
        r.el.removeAttribute('href');
        $this.m.pbu.hide(linkIcon);
        $this.m.pbu.removeClass(r.el,['sp-route-link','sp-detail']);
      }
    return true;
}
}//inner()
}//func

/**
 * 
 * @param {any} data 
 * @returns {HTMLElement}
 */
async getSocialBlock(data={}){
let $this = this;
let {type='new',v={bs:[{n:'facebook',h:'https://www.facebook.com'}]},dClass=[]} = data;
let elClass = ['sp-block','sp-social','btn-group',...dClass];
let r = await this.getBlockContainer({name:'social',main:'div',clasz:elClass,cmCallback:attachEvents});

for(let b of v.bs){
    getNew(b.n,b.h);
}
//
this.restoreAttributes('social',r.el,v);
if(this.isView){
    
}else{
let handle = this.main.pbu.createElement('div',['sp-handle','mt-2']);
r.el.after(handle);
handle.appendChild(await this.main.pbu.getDropdown({cb:async (n)=>{
    getNew(n);
},name:"Add",items:Object.keys(this.socialButtons)}));

attachEvents(null);
}
//finally
return r.bc;

/**
 * 
 * @param {string} n -name
 * @param {string} h -href
 */
async function getNew(n,h=''){
n = n.toLocaleLowerCase();
let icon = (n=='twitter')?'twitter-x':n;
if(!h){
h = $this.socialButtons[n];
}
$this.getButtonBlock({
type:type,
    parent:'social',
    v:{
    t:n,
    h:h,
    ic:icon,
    si:'md',
    al:'left'
    },
    dClass:['me-2','rounded-1','sp-social','btn-social',`btn-${n}`]}).
then(b=>{
    r.el.appendChild(b);
    $this.m.pbu.removeClass(b,['sp-route-link','sp-detail']);
}
    
);
}//inner
/**
 * 
 * @param {boolean|null} save 
 */
async function attachEvents(save){
if(save==null){
}else if(save==false){

}else if(save==true){
    return true;
}
}//inner()

}//func
/**
 * 
 * @param {any} data 
 * @returns {HTMLElement}
 */
async getRichTextBlock(data={}){
let $this = this;
let {type='new',parent=null,v=this.ep.richText.data,dClass=[]} = data;
v = {...this.ep.richText.data,...v};
let elClass = ['sp-block','sp-rich-text','formatable','sp-main-text',...dClass];
let r =await this.getBlockContainer({name:'richText',main:'main',parent:parent,clasz:elClass,cmCallback:attachEvents});
r.el.innerHTML =  v.t;
this.restoreAttributes('richText',r.el,v);
if(this.isView){

}else{
r.el.contentEditable = 'true';
this.makeEditable(r.el);
attachEvents(null);
}
//finally
return (this.isView && parent)? r.el: r.bc;
/**
 * 
 * @param {boolean|null} save 
 */
async function attachEvents(save){
if(save==null){
}else if(save==false){
}else if(save==true){
    return true;
}

}//inner

}//func
/**
 * 
 * @param {any} data 
 * @returns {HTMLElement}
 */
async getTableBlock(data={}){
let {type='new',v={v:'n'},dClass=[]} = data;
let $this = this;
//temp solution
if(this.main.host=='godlysensation.com' || this.main.host=='godlysensation.senplat.com'){
 v.v='w';
}
let isWrite = v.v=='w';//write

let count = (isWrite)? 1 :3;
let elClass = ['sp-block','sp-table','formatable',...dClass];
let r =await this.getBlockContainer({name:'table',main:'div',clasz:elClass,cmCallback:attachEvents});
r.el.innerHTML = 
`
<div class="table-responsive">
<table class="table ${this.main.pbu.addClassIf(isWrite,['table-striped'])}">
<thead class="">
<tr class="sp-delete-column"></tr>
<tr class="sp-thead-row"></tr>
</thead>
  <tbody>
  </tbody>
</table>
</div>

<div class="d-flex sp-handle ${this.main.pbu.showIf(!this.isView)}">
<a type="button" class="sp-table-add-row btn btn-outline-secondary btn-sm me-2">Add Row ${await this.main.pbu.getSvg('plus-square-dotted')}</a>
<a type="button" class="sp-table-add-column btn btn-outline-secondary btn-sm me-2 ${this.main.pbu.showIf(!isWrite)}">Add Column ${await this.main.pbu.getSvg('plus-square-dotted')}</a>
</div>
`;
let theadRow  = r.el.querySelector('thead tr.sp-thead-row');
let theadRemoveColumRow = r.el.querySelector('thead tr.sp-delete-column');
let tbody = r.el.querySelector('tbody');
let addRowButton= r.el.querySelector('.sp-table-add-row');
let addColumnButton = r.el.querySelector('.sp-table-add-column');
if(type=='new'){
for(let i=0;i<count;i++){//number of column
this.main.pbu.appendChild(theadRemoveColumRow,`<th scope="col" class="text-center"><a type="button" id="a${this.main.utils.getRandomInt()}" class="sp-table-remove-column btn btn-outline-secondary btn-sm me-2">${await this.main.pbu.getSvg('dash-square-dotted')}</a></th>`);
this.main.pbu.appendChild(theadRow,`<th class="sp-th" scope="col"><input class="form-control"/></th>`);
tbody.appendChild(await addNewRow(null));
}

}else{
      if(v.trv){
        count = v.thv.length;//number of column
        for(let i=0;i<count;i++){
        if(this.isView){
        this.main.pbu.appendChild(theadRow,`<th class="sp-th" scope="col">${v.thv[i]}</th>`);
        }else{
        this.main.pbu.appendChild(theadRemoveColumRow,`<th scope="col" class="text-center"><a type="button" id="a${this.main.utils.getRandomInt()}" class="sp-table-remove-column btn btn-outline-secondary btn-sm me-2">${await this.main.pbu.getSvg('dash-square-dotted')}</a></th>`);
        this.main.pbu.appendChild(theadRow,`<th class="sp-th" scope="col"><input class="form-control" value="${v.thv[i]}"/></th>`);
        }

        }
        for(let i=0;i<v.trv.length;i++){
        tbody.appendChild(await addNewRow(v.trv[i]));
        }
    }

}
this.restoreAttributes('table',r.el,v);
if(this.isView){
}else{
r.el.setAttribute('v',v.v);
attachEvents(null);
}
//finally
return r.bc;
//
/**
 * 
 * @param {string[]|null} t 
 */
async function addNewRow(t){
let tr = $this.main.pbu.createElement('tr',['sp-tr']);
let tds;
if(t){
tds = t;
}
for(let i=0;i<count;i++){
if(t){
    $this.main.pbu.appendChild(tr,getTd(tds[i]));
}else{
$this.main.pbu.appendChild(tr,getTd(''));
}

}
if(! $this.isView){
let td = $this.main.pbu.createElement('td',['sp-delete']);
tr.appendChild(td);
td.appendChild(await $this.main.pbu.getDropdown({cb:async (v)=>{
switch(v.trim()){
    case 'Delete':
        tr.remove();
        break;
    case 'Move Up':
        $this.moveBlock(tr,'up');
        break;
    case 'Move Down':
        $this.moveBlock(tr,'down');
        break;
    case 'Insert Before':
        tr.before(await addNewRow(null));
        break;
    case 'Insert After':
        tr.after(await addNewRow(null));
        break;
}
},icon:'three-dots-vertical',items:['Delete','Move Up','Move Down','Insert Before','Insert After']}));
}
return tr;
}//inner

function addNewColumn(){
$this.main.pbu.appendChild(theadRow,`<th class="sp-th" scope="col"><input class="form-control"/></th>`);
let buttonId = `a${$this.main.utils.getRandomInt()}`;
$this.main.pbu.appendChild(theadRemoveColumRow,`<th scope="col"><a id="${buttonId}" class="sp-table-remove-column btn btn-sm">X</a></th>`);
let b = theadRemoveColumRow.querySelector(`#${buttonId}`);
$this.main.pbu.listen(b,'click',()=>{
removeColumn(b);
});

let trs = r.el.querySelectorAll('tr.sp-tr');
for(let tr of trs){
    let td = getTd('');
    let remove = tr.querySelector('td.sp-delete');
    remove.before(td);
}
count += 1;
}//inner

/**
 * 
 * @param {string} value 
 * @returns 
 */
function getTd(value=''){
let td = $this.main.pbu.createElement('td',['sp-td']);
td.innerHTML = `<div ${$this.main.pbu.setAttributeIf(!$this.isView,[{n:"contenteditable",v:"plaintext-only"}])}>${value}</div>`;
if(!$this.isView){
    $this.makeEditable(td.querySelector('div'));
}
return td;
}//inner

/**
 * 
 * @param {HTMLElement} b 
 */
function removeColumn(b){
    //firstly
    let ths = theadRow.querySelectorAll('th');
     if(ths.length==1){
        $this.main.utils.notify('Cant remove',{level:1});
        return;
    }
    //get index of target element
    let idx;
    let buttons = r.el.querySelectorAll('a.sp-table-remove-column');
    for(let i=0;i<buttons.length;i++){
        if(b.id==buttons[i].id){
            idx=i;
            break;
        }
    }
    
    ths[idx].remove();//??
   /**@type {NodeList}*/let trs = r.el.querySelectorAll('tr.sp-tr');
   for(let tr of trs){
    let tds = tr.querySelectorAll('td.sp-td');
    tds[idx].remove();
   }
   b.parentElement.remove();
   count -=1;
}//inner
/**
 * 
 * @param {boolean|null} save 
 */
function attachEvents(save){
let settingsTemplate;
if(save==null){
$this.main.pbu.listen(addRowButton,'click',async ()=>{
tbody.appendChild(await addNewRow(null));
});
//
$this.main.pbu.listen(addColumnButton,'click',()=>{
addNewColumn();
});

let removeColumnButtons = r.el.querySelectorAll('.sp-table-remove-column');
for(let b of removeColumnButtons){
$this.main.pbu.listen(b,'click',()=>{
removeColumn(b);
});
}
}else if(save==false){

}else if(save==true){
    return true;
}

}//inner

}//func

/**
 * 
 * @param {any} data 
 * @returns {HTMLElement}
 */
async getListBlock(data={}){
let $this = this;
let {type='new',v={v:'ul',li:[]},dClass=[]} = data;
let isOrdered = v.v=='ol';
let elClass = ['sp-block','sp-list','formatable',...dClass];
let r =await this.getBlockContainer({name:'list',main:'div',clasz:elClass,cmCallback:attachEvents});
r.el.innerHTML = 
`
<${v.v} class="list-group list-group-flush sp-list-group ${this.main.pbu.addClassIf(isOrdered,['list-group-numbered'])}">
</${v.v}>
`;
if(!this.isView){
r.el.appendChild(this.main.tu.getSaveButton({cb:()=>$this.main.pbu.appendChild(list,getLi()),textContent:"Add Item",keepActive:true,clasz:['btn-sm'],iconClasz:['bi-file-plus']}));
}
let list = r.el.querySelector('.sp-list-group');
if(type=='new'){
this.main.pbu.appendChild(list,getLi());
}else{
for(let i of v.li){
this.main.pbu.appendChild(list,getLi(i));
}
}
this.restoreAttributes('list',r.el,v);
if(this.isView){
}else{
attachEvents(null);
}
//finally
return r.bc;
//

/**
 * 
 * @param {string} value 
 * @returns 
 */
function getLi(value=''){
let li = $this.main.pbu.createElement('li',['list-group-item','position-relative','sp-li']);
if($this.isView){
    li.innerHTML = (isOrdered)?value: `<i class="mx-2 bi bi-check-circle"></i>${value}`;
}else{
    $this.main.pbu.appendChild(li,
    `
    <div class="d-flex">
    <i class="sp-bi bi bi-check-circle ${$this.main.pbu.showIf(!isOrdered)}"></i>
    <div class="sp-li mx-2 bg-secondary" style="width: 95%;max-width: 100%;" ${$this.main.pbu.setAttributeIf(!$this.isView,[{n:"contenteditable",v:"plaintext-only"}])}>${value}</div>
    </div>
    `,
    $this.main.tu.getSaveButton({textContent:"x",keepActive:true,btnColor:['btn-danger'],clasz:['btn-sm','btn-danger','ms-4','position-absolute','z-10'],style:"right: -25px;top: 25%;",
        cb:()=>{
            if(list.children.length==1){
            $this.main.utils.notify('Cant remove',{level:1});
            }else{
                li.remove();
            }
        }
    }));

    $this.makeEditable(li.querySelector('div.sp-li'));
    
}
return li;
}//inner

/**
 * 
 * @param {boolean|null} save 
 */
async function attachEvents(save){

if(save==null){
let settingsTemplate = $this.main.pbu.createSelectElement({title:"List Type",value:v.v,el:r.el,attr:'v',defaultValue:'ul',items:['ul','ol'],cb:(variant)=>{
if(variant!=v.v){
    //NOTE: cant replace html tag 
    let newList = $this.main.pbu.createElement(variant,['list-group','sp-list-group']);
    if(variant=='ol'){
        isOrdered = true;//important
        $this.main.pbu.addClass(newList,['list-group-numbered']);
    }
    let values = [...r.el.querySelectorAll('.sp-list div.sp-li')].map(i=>i.innerHTML);
    for(let value of values){
        $this.main.pbu.appendChild(newList,getLi(value));
    }
    list.remove();
    r.el.prepend(newList);
    list = newList;
    v.v = variant;
}
}});
$this.m.pbu.appendChild(r.cMenu.otherSettings,settingsTemplate);
}else if(save==false){

}else if(save==true){
return true;
}
}//inner
}//func

/**
 * Image block is often used by other components outside pagebuilder,
 * may have additional properties like divClass 
 * @param {any} data 
 * @returns {HTMLElement}
 */
async getImageBlock(data={}){
let $this = this;
let {type='new',parent=null,v=this.ep.image.data,dClass=[]} = data;
v = {...this.ep.image.data,...v};
let elClass = ['main-media','img-fluid','mx-auto','sp-block','sp-image',...dClass];
let r = await this.getBlockContainer({name:'image',main:'img',parent:parent,clasz:elClass,parentClasz:['main-media-container','text-center','mx-auto'],cmCallback:attachEvents});
r.el.setAttribute('data-media-type','image');
if(v.src){
    r.el.src = v.src;
    r.el.setAttribute('data-src',v.src);
}

this.restoreAttributes('image',r.el,v);
if(this.isView){

}else{
//let handle = this.m.pbu.createElement('div');
this.m.pbu.appendChild(r.parent,
`
<div class="delete-media my-2 text-center d-block"></div>
</div>

<div class="media-trigger my-2 text-center d-block  d-none"></div>

`);

let mediaTrigger = r.parent.querySelector('div.media-trigger');
let imageDiv = r.parent;
//let image = r.el.querySelector('img.main-media');

this.m.media.getMediaTrigger('image',imageDiv).then(r=>{
    this.main.pbu.replace(mediaTrigger,r,true);
});
attachEvents(null);
}

//finally
return (this.isView && parent)? r.el: r.bc;
/**
 * 
 * @param {boolean|null} save 
 */
async function attachEvents(save){
if(save==null){
let settingsTemplate = $this.main.pbu.createSelectElement({title:"Image Height",value:$this.main.utils.getIf(v.ht,'default'),el:{parent:r.parent,elSelector:'img.main-media'},attr:'ht',defaultValue:'default',items:['25vh','50vh','75vh','100vh','default']});
$this.m.pbu.appendChild(r.cMenu.otherSettings,settingsTemplate);
}else if(save==false){

    
}else if(save==true){
return true;
}

}//inner()

}//func

/**
 * 
 * @param {any} data 
 * @returns {HTMLElement}
 */
async getAudioBlock(data={type:'new',v:{src:''},dClass:[]}){
let $this = this;
let elClass = ['sp-block','sp-audio',...data.dClass];
let r = await this.getBlockContainer({name:'audio',main:'div',clasz:elClass,cmCallback:attachEvents});
let div = await this.main.media.getMediaTemplate({src:data.v.src,mediaType:'audio',isView:this.isView});
r.el.appendChild(div);
this.restoreAttributes('audio',r.el,data.v);
if(this.isView){
}else{
attachEvents(null);
}
//finally
return r.bc;
/**
 * 
 * @param {boolean|null} save 
 */
async function attachEvents(save){
if(save==null){
}else if(save==false){

}else if(save==true){
    return true;
}

}//inner()

}//func
/**
 * 
 * @param {any} data 
 * @returns {HTMLElement}
 */
async getVideoBlock(data={type:'new',v:{src:''},dClass:[]}){
let $this = this;
let elClass = ['sp-block','sp-video',...data.dClass];
let r = await this.getBlockContainer({name:'video',main:'div',clasz:elClass,cmCallback:attachEvents});
let div = await this.main.media.getMediaTemplate({src:data.v.src,mediaType:'video',isView:this.isView});
r.el.appendChild(div);
this.restoreAttributes('video',r.el,data.v);
if(this.isView){
}else{
attachEvents(null);
}
//finally
return r.bc;
/**
 * 
 * @param {boolean|null} save 
 */
async function attachEvents(save){
if(save==null){
}else if(save==false){

}else if(save==true){
    return true;
}

}//inner()

}//func


/**
 * 
 * @param {any} data 
 * @returns {HTMLElement}
 */
async getFormBlock(data={}){
let $this = this;
let {type='new',v={ts:[],mp:''},dClass=[]} = data;
let elClass = ['sp-block','sp-form','w-100','sp-contact-form',...dClass];
/**@type {HTMLElement}*/let controls;
/**@type {HTMLElement}*/let addField;
let r = await this.getBlockContainer({name:'form',main:'form',clasz:elClass,cmCallback:attachEvents});
//section for controls
controls = this.main.pbu.createElement('div',['sp-form-controls']);
this.main.pbu.appendChild(r.el,controls);
//initial field
if(type=='new'){
controls.appendChild(await this.getFormControl());
}else{
        //current version
        for(let title of v.ts){
        this.main.pbu.appendChild(controls,await this.getFormControl({
            type:title.tp,
            title:title.t,
            required:this.main.utils.getBit(title.r,false),
            placeholder:title.cp
        })
        
        );
    }
    
}

//section for message ie textarea
//note:class="sp-form-message" :INTENTIONAL
let div2 = 
`
<div class="sp-form-control ${this.blockMargin}">
<label for="sp-form-message" class="sp-form-message">Message</label>
<textarea  id="sp-form-message" rows="3" class="sp-form-control form-control sp-form-message sp-validation-required"></textarea>
</div>

<div>
<a type="button" class="btn btn-primary sp-form-submit-button">Submit</a>
<div>
<a type="button" class="${this.main.pbu.showIf(!this.isView)} sp-form-add-field btn btn-primary btn-sm float-end">+ Add Field</a>
`;

this.main.pbu.appendChild(r.el,div2);
let textarea = r.el.querySelector('textarea');
//
this.restoreAttributes('form',r.el,v);
if(this.isView){
textarea.placeholder = v.mp || '';
processForms();
}else{
textarea.placeholder = 'Enter placeholder here';
if(v.mp){
textarea.value = v.mp;
}
attachEvents(null);
}
//finally
return r.bc;

/**
 * 
 * @param {boolean|null} save 
 */
async function attachEvents(save){
if(save==null){
addField = r.el.querySelector('a.sp-form-add-field');
$this.main.pbu.listen(addField,'click',async ()=>{
$this.main.pbu.appendChild(controls,await $this.getFormControl());
},$this.parent);
}else if(save==false){

}else if(save==true){
    return true;
}
//
}//inner

async function processForms() {
let phoneFields = [...r.el.querySelectorAll('input[type=tel]')];
for(let pf of phoneFields){
$this.main.intlTelInput(pf, {
  strictMode: true,
  loadUtils: () => import("intl-tel-input/utils"),
});
};
// for(let pf of phoneFields){
// $this.main.intlTelInput(pf, {
//   onlyCountries: ["us","ca","ng"],
//   strictMode: true,
//   loadUtils: () => import("intl-tel-input/utils"),
// });
// };
//
let submitButton = r.el.querySelector('.sp-form-submit-button');
$this.main.pbu.listen(submitButton,'click',async ()=>{
    //let controls = [...r.el.querySelectorAll('.sp-form-control:not(div)')];
    let controls = [...r.el.querySelectorAll('input.sp-form-control')];
    if(controls.length>0){
        //temp:
        if(!$this.main.vu.validate([...controls,textarea])){return;}
    let title,value;
    let message = "";
    for(let c of controls){
        title = c.closest('div.sp-form-control').querySelector('.sp-form-title').textContent;
        value = c.value;
        message += `<p>${title}:${value}</p>`;
    }
    //if(!$this.main.vu.validate(textarea)){return;}
    //add main message from textarea
    message += `<p>Message:${textarea.value}</p>`;
    $this.main.log(message,'Post.processForms(): message to submit');
    let r = await $this.main.fu.fetch({
        link:$this.main.fu.getApi('submit-contact-form'),
        body:message
    });
    if(r =='sent'){
        $this.main.pbu.appendChild(submitButton.parentElement,
    `<p class="border border-success mt-2 p-2">Thank you for your message. We will get back to you shortly</p>`);
    $this.main.pbu.addClass(submitButton,['disabled']);
    }
}
});
  }//func

}//func
/**
 * @returns {HTMLElement}
 */
async getFormControl(data={}){
let $this = this;
let{
type = 'text',
title='Title',
required=true,
placeholder=''
} = data;

let row = this.main.pbu.createElement('div',['row']);
row.innerHTML = 
`
<div class ="${this.main.pbu.addClassIf(this.isView,['col-12'],['col-8'])}">
<div class="${this.blockMargin} sp-form-control">
<label data-type="${type}" ${this.main.pbu.setAttributeIf(!this.isView,[{n:"contenteditable",v:"plaintext-only"}])} class="sp-form-title form-label">${title}</label>
<input type="${type}" class="sp-form-control form-control ${this.main.pbu.addClassIf(required,['sp-validation-required'])}"/>
</div>
</div>
<div class ="d-flex col-4 sp-form-handle ${this.main.pbu.showIf(!this.isView)} position-relative">
<input ${required?'checked':''} type="checkbox" class="form-check-input sp-checkbox mx-1"/>
${this.main.pbu.createSelectElement({serialize:true,value:type,items:['text','number','email','tel','url']})}
<a style="right: 0px;top: 50%;z-index: 101;" type="button" class="sp-form-remove-field btn btn-sm btn-danger position-absolute">X</a>
</div>
`;
//NOTE:other variables re drfined in attachEvents() to optimize view
let control = row.querySelector('input.sp-form-control');
if(this.isView){
control.placeholder = placeholder;
}else{
control.placeholder = 'Enter placeholder here';
control.value = placeholder;
attachEvents();
}
return row;
async function attachEvents(){
let title = row.querySelector('label.sp-form-title');
let typeSelector = row.querySelector('select.sp-select');
let requiredValidationInput = row.querySelector('input.sp-checkbox');
let remove = row.querySelector('a.sp-form-remove-field');
//
$this.main.pbu.listen(requiredValidationInput,'click',()=>{
    if(requiredValidationInput.checked){
        $this.main.pbu.addClass(control,['sp-validation-required']);
    }else{
        $this.main.pbu.removeClass(control,['sp-validation-required']);
    }
},$this.parent,[title,control,typeSelector,requiredValidationInput,remove]);
//
$this.main.pbu.listen(typeSelector,'change',()=>{
    control.type = typeSelector.value;
    title.setAttribute('data-type',typeSelector.value);
},$this.parent);
//
$this.main.pbu.listen(remove,'click',()=>{
    row.remove();
},$this.parent);
}//inner
}//func

/**
 * 
 * @param {any} data 
 * @returns {HTMLElement}
 */
async getCoverComponent(data={}){
let $this = this;
let {type='new',dClass=[],v={image:{src:''},heading:{t:'Heading',sh:'0',si:'lg',ic:'',al:'center'},body:{t:this.initialText,al:'center'},button1:{t:'Learn more',al:'center'},button2:{}}} = data;
let elClass = ['sp-component','sp-cover','container-fluid','sp-border',...dClass];
let r = await this.getBlockContainer({name:'cover',main:'main',clasz:elClass,cmCallback:attachEvents});
r.el.innerHTML = 
 `
<div>
<div class="sp-cover-image text-center"></div>
    <div class="col-lg-6 mx-auto">
      <div class="sp-button-section d-grid gap-2 d-sm-flex justify-content-center">
      </div>
    </div>
</div>
`;

//handle
let coverImageDiv = r.el.querySelector('div.sp-cover-image');
let buttonSection = r.el.querySelector('.sp-button-section');
let buttonClass = ['sp-cover-button','px-4','gap-3'];

let image = await this.getImageBlock({type:type,parent:'cover',v:{src:v.image?.src,wt:'57px',ht:'72px'},dClass:['cover-image']});

let heading = await this.getHeadingBlock({
    type:type,
    parent:'cover',
    v:{
        t:v.heading.t,
        ic:v.heading.ic,
        sh:v.heading.sh,
        si:v.heading.si,
        al:v.heading.al
    },
    dClass:['display-5','fw-bold', 'text-body-emphasis']
});

let body = await this.getRichTextBlock({
    type:type,
    parent:'cover',
    v:{
        t:v.body.t,
        al:v.body.al
    },
    dClass:['lead', 'mb-4']
});
coverImageDiv.after(heading);
buttonSection.before(body);
//
buttonSection.innerHTML = '';

buttonSection.appendChild(await this.getButtonBlock({
    type:type,
    parent:'cover',
    v:{
    t:v.button1.t,
    h:v.button1.h,
    ic:v.button1.ic,
    si:v.button1.si,
    al:v.button1.al
    },
    dClass:buttonClass
}));  


    if(v.button2?.t){
    buttonSection.appendChild( await this.getButtonBlock({
    type:type,
    parent:'cover',
    v:{
    t:v.button2.t,
    h:v.button2.h,
    ic:v.button2.ic,
    si:v.button2.si,
    al:v.button2.al
    },
    dClass:buttonClass
    
}));
    }

this.restoreAttributes('cover',r.el,v);
if(this.isView){
//remember image if optional for cover
if(v.image?.src){
coverImageDiv.appendChild(image);
}
}else{
coverImageDiv.appendChild(image);
attachEvents(null);
}
//finally
return r.bc;

/**
 * 
 * @param {boolean|null} save 
 */
async function attachEvents(save){
if(save==null){
let addButton = await $this.m.pbu.getEventButton('Add 2nd button',{cb:async()=>{
if(buttonSection.children.length==1){
let button = await $this.getButtonBlock({type:type,parent:'cover',v:{t:'Learn more',al:'center'},dClass:buttonClass});
$this.m.pbu.appendChild(buttonSection,button);
addButton.textContent = 'Remove 2nd button';
}
else if(buttonSection.children.length==2){
buttonSection.removeChild(buttonSection.lastElementChild);
addButton.textContent = 'Add 2nd button';
}
}});
$this.m.pbu.appendChild(r.cMenu.otherSettings,addButton);
}else if(save==false){

}else if(save==true){
    return true;
}
}//

}//func

/**
 * 
 * @param {any} data 
 * @returns {HTMLElement}
 */
async getHeroComponent(data={}){
let $this = this;
let {type='new',dClass=[],v={image:{src:''},heading:{t:'Heading',sh:'0',si:'lg',ic:'',al:'center'},body:{t:this.initialText,al:'center'},button:{t:'Learn more',al:'center'}}} = data;
let elClass = ['sp-component','sp-hero','container',...dClass];
let r =await this.getBlockContainer({name:'hero',main:'div',clasz:elClass,cmCallback:attachEvents});
r.el.innerHTML = 
`
<div class="row">
  <!-- Column 1: Second on mobile, First on desktop -->
  <div class="col-md-6 order-2 order-md-1 d-flex flex-column justify-content-center sp-col1">
  
  </div>
  
  <!-- Column 2: First on mobile, Second on desktop -->
  <div class="col-md-6 order-1 order-md-2 sp-col2">
</div>
`;
//Handle
let col1 = r.el.querySelector('div.sp-col1');
let col2 = r.el.querySelector('div.sp-col2');

let heading = await this.getHeadingBlock({
    type:type,
    parent:'hero',
    v:{
        t:v.heading.t,
        ic:v.heading.ic,
        sh:v.heading.sh,
        si:v.heading.si,
        al:v.heading.al
    },
    dClass:['sp-hero-heading']
});
//Body
let body = await this.getRichTextBlock({
    type:type,
    parent:'hero',
    v:{
        t:v.body.t,
        al:v.body.al
    },
    dClass:['sp-hero-body']
});
//button
//BUTTON have defaults, getIf will be redundant
let button = await this.getButtonBlock({
    type:type,
    parent:'hero',
    v:{
    t:v.button.t,
    h:v.button.h,
    ic:v.button.ic,
    si:v.button.si,
    al:v.button.al
    }
});

let image = await this.getImageBlock({
    type:type,
    parent:'hero',
    v:{
        src:v.image.src,
        ht:v.image.ht,
    },
    dClass:['hero-image']
});
//
let buttonDiv = this.main.pbu.createElement('div',['d-flex', 'justify-content-center']);
buttonDiv.appendChild(button);
this.main.pbu.appendChild(col1,heading,body,buttonDiv);
this.main.pbu.appendChild(col2,image);
//
this.restoreAttributes('hero',r.el,v);
if(this.isView){

}else{
attachEvents(null);
}
//finally
return  r.bc;
/**
 * 
 * @param {boolean|null} save 
 */
async function attachEvents(save){
if(save==null){
}else if(save==false){
}else if(save==true){
    return true;
}

}//inner

}//func

/**
 * 
 * @param {any} data 
 * @returns {HTMLElement}
 */
async getCardComponent(data={}){
let $this = this;
let epHeading = this.m.utils.clone(this.ep.heading.data);
epHeading.al = 'center';
let epRichText = this.m.utils.clone(this.ep.richText.data);
epRichText.al = 'center';
let epButton = this.m.utils.clone(this.ep.button.data);
epButton.al = 'center';

let {type='new',dClass=[],v={eh:'0',image:this.ep.image.data,heading:epHeading,body:epRichText,button:epButton}} = data;
let elClass = ['sp-component','sp-card','card',this.blockMargin,...dClass];//??
let r = await this.getBlockContainer({name:'card',main:'div',clasz:elClass,cmCallback:attachEvents});
this.main.pbu.appendChild(r.el,
 `
  <div class="card-body sp-card-body">
    
    
    </div>
    <div class="sp-card-button-section d-flex justify-content-center"></div>
  `
);
let cardBody = r.el.querySelector('.sp-card-body');
let cardButtonSection =  r.el.querySelector('.sp-card-button-section');
let image = await this.getImageBlock({type:type,parent:'card',v:{src:v.image?.src,ht:v.image?.ht},dClass:['card-image']});

//this.main.pbu.removeClass(image,['sp-required']);
//required
let heading = await this.getHeadingBlock({
    type:type,
    parent:'card',
    v:{
        t:v.heading.t,
        ic:v.heading.ic,
        sh:v.heading.sh,
        si:v.heading.si,
        al:v.heading.al
    },
    dClass:[]
});
//card may not have a button, evident when editing
let body = await this.getRichTextBlock({
    type:type,
    parent:'card',
    v:{
        t:v.body?.t,
        al:v.body?.al
    },
    dClass:[]
});
//this.main.pbu.removeClass(body,['sp-required']);
this.main.pbu.appendChild(cardBody,heading,body);
if(v.button){
    let button = await this.getButtonBlock({
    type:type,
    parent:'hero',
    v:{
    t:v.button.t,
    h:v.button.h,
    ic:v.button.ic,
    si:v.button.si,
    al:v.button.al
    }
});
this.m.pbu.replace(cardButtonSection,button);
}else{
    if(!this.m.isView){
    let eventButton = await this.m.pbu.getEventButton('Add button',{cb:async ()=>{
    let button = await this.getButtonBlock({
    type:type,
    parent:'hero',
    v:{
    t:'Learn more',
    si:'md',
    al:'center'
    }
});
this.m.pbu.replace(cardButtonSection,button);
    },withDiv:false});
    //prevent saving this field
    this.m.pbu.removeClass(eventButton,['sp-button']);
    this.m.pbu.replace(cardButtonSection,eventButton);
    }
}
///
this.restoreAttributes('card',r.el,v);
if(this.isView){
if(v.image?.src){
r.el.prepend(image);
}
}else{
r.el.prepend(image);
attachEvents(null);
}
//finally
return r.bc;
/**
 * 
 * @param {boolean|null} save 
 */
async function attachEvents(save){
if(save==null){
let equalHeight = $this.main.pbu.createCheckedInputElement({value:v.eh,isBool:true,el:r.el,attr:'eh',items:['Equal Height?']});
$this.m.pbu.appendChildIf(r.cMenu.otherSettings,equalHeight);
}else if(save==false){

}
if(save==true){
    return true;
}
}//inner
}//func


/**
 * 
 * @param {any} data 
 * @returns {HTMLElement}
 */
async getCtaComponent(data={}){
let $this = this;
let {type='new',v={heading:{t:'Heading',sh:'1',si:'md',ic:'',al:'left'},body:{t:this.initialText,al:'left'},button:{t:'Learn more',al:'center',si:'lg'}},dClass=[]} = data;
let elClass = ['sp-component','sp-cta','row','sp-border','p-2',...dClass];
let r = await this.getBlockContainer({name:'cta',main:'main',clasz:elClass,cmCallback:attachEvents});
//
r.el.innerHTML =
 `
 <div class="sp-col1 col-md-8">

 </div>

  <div class="sp-col2 col-md-4 d-flex align-items-center justify-content-center">
  </div>
 `;
//append block to col1
let col1 = r.el.querySelector('.sp-col1');
let col2 = r.el.querySelector('.sp-col2');

let heading = await this.getHeadingBlock({
    type:type,
    parent:'cta',
    v:{
        t:v.heading.t,
        ic:v.heading.ic,
        sh:v.heading.sh,
        si:v.heading.si,
        al:v.heading.al
    },
    dClass:[]
});

let body = await this.getRichTextBlock({
    type:type,
    parent:'card',
    v:{
        t:v.body.t,
        al:v.body.al
    },
    dClass:[]
});
this.main.pbu.appendChild(col1,heading,body);
//append block to col2
let button = await this.getButtonBlock({
    type:type,
    parent:'cta',
    v:{
    t:v.button.t,
    h:v.button.h,
    ic:v.button.ic,
    si:v.button.si,
    al:v.button.al
    }
});

col2.appendChild(button);
this.restoreAttributes('cta',r.el,v);
if(this.isView){
//add route link to button
}else{
attachEvents(null);
}
//finally
return r.bc;
/**
 * 
 * @param {boolean|null} save 
 */
async function attachEvents(save){
if(save==null){
}else if(save==false){

}else if(save==true){
    return true;
}

}//inner
}//func
/**
 * 
 * @param {any} data 
 * @returns {HTMLElement}
 */
async getFaqComponent(data={}){
let $this = this;
let {type='new',v={heading:{t:'FAQ TITLE',sh:'1',si:'md',ic:'',al:'left'},qas:[{q:'What is Love?',a:this.initialText}]},dClass=[]} = data;
let elClass = ['sp-component','sp-faq',...dClass];
let r = await this.getBlockContainer({name:'faq',main:'main',clasz:elClass,cmCallback:attachEvents});
//
this.main.pbu.appendChild(r.el,
`
<div class="row q-and-a">
</div>
 <div class="sp-faq-footer ${this.main.pbu.showIf(!this.isView)}">
    <a type="button" class="btn btn-sm btn-primary sp-faq-button" contenteditable="false">Add FAQ</a>
</div>
`
);

let questionAndAnswerSection = r.el.querySelector('.q-and-a');
let addFaq = r.el.querySelector('.sp-faq-button');

let heading = await this.getHeadingBlock({
    type:type,
    parent:'faq',
    v:{
        t:v.heading.t,
        ic:v.heading.ic,
        sh:v.heading.sh,
        si:v.heading.si,
        al:v.heading.al
    },
    dClass:['sp-faq-title']
});
this.main.pbu.prependChild(r.el,heading);
 questionAndAnswerSection.innerHTML = '';
    for(let qa of v.qas){
    this.main.pbu.appendChild(questionAndAnswerSection,getQa(qa.q,qa.a));
}

this.restoreAttributes('faq',r.el,v);
if(!this.isView){
attachEvents(null);
}
//finally
return r.bc;

/**
 * 
 * @param {string} q 
 * @param {string} a 
 * @returns 
 */
function getQa(q='What is Love?',a=$this.initialText) {
return `
<div>
<h5 ${$this.main.pbu.setAttributeIf(!$this.isView,[{n:"contenteditable",v:"plaintext-only"}])} class="sp-faq-question">${q}</h5>
<p ${$this.main.pbu.setAttributeIf(!$this.isView,[{n:"contenteditable",v:"plaintext-only"}])} class="sp-faq-answer">${a}</p>
</div>
`;
}//inner
/**
 * 
 * @param {boolean|null} save 
 */
async function attachEvents(save){
if(save==null){
$this.main.pbu.listen(addFaq,'click',()=>{
$this.main.pbu.appendChild(questionAndAnswerSection,getQa());
});
}else if(save==false){

}else if(save==true){
    return true;
}
}//inner
}//func

/**
 * 
 * @param {any} data 
 * @returns {HTMLElement}
 */
async getSubscribeComponent(data={}){
let $this = this;
let {type='new',dClass=[],v={heading:{},body:{},button:{}}} = data;
let elClass = ['sp-component','sp-subscribe',...dClass];
let r =await this.getBlockContainer({name:'subscribe',main:'div',clasz:elClass,cmCallback:attachEvents});
r.el.innerHTML = 
`
<div class="container sp-container py-4">
  <div class="row justify-content-center">
    <div class="${this.main.pbu.addClassIf(this.isView,['col-md-8','col-lg-6'],['col-12'])}">
      <!-- Card wrapper -->
      <div class="card shadow-sm border-0">
        <div class="card-body p-4 p-md-5">
          <!-- Icon & Header -->
          <div class="text-center mb-4">
            ${await this.main.pbu.getSvg('envelope-paper',{width:'50',height:'50',clasz:['sp-primary']})}
            <div class="sp-heading"></div>
            <div class="sp-body"></div>
          </div>
          
          <!-- Form with inline classes -->
          <form class="row g-3 align-items-center sp-subscribe">
          ${this.main.pbu.createFormControl({title:"Name",clasz:['name'],placeholder:'Enter your name',required:true,serialize:true})}
          ${this.main.pbu.createFormControl({title:"Email",clasz:['email'],placeholder:'Enter your email',required:true,serialize:true})}
          <div class="d-flex justify-content-center sp-subscribe-button"></div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
`;
//Handle
let heading = r.el.querySelector('div.sp-heading');
let body = r.el.querySelector('div.sp-body');
let form = r.el.querySelector('form.sp-subscribe');
let buttonDiv = r.el.querySelector('div.sp-subscribe-button');

this.getHeadingBlock({
    type:type,
    parent:'subscribe',
    v:{
        t:this.main.utils.getIf(v.heading.t,'Subscribe to Our Newsletter'),
        sh:this.main.utils.getIf(v.heading.sh,'0'),
        si:this.main.utils.getIf(v.heading.si,'md'),
        al:this.main.utils.getIf(v.heading.al,'center'),
    },
    dClass:['sp-subscribe-heading']
}).then(r=>{
    this.main.pbu.replace(heading,r);
});
//Body
this.getRichTextBlock({
    type:type,
    parent:'subscribe',
    v:{
        t:this.main.utils.getIf(v.body?.t,'Get our latest posts delivered right to your inbox.')
    },
    dClass:['sp-subscribe-body']
}).then(r=>{
    this.main.pbu.replace(body,r);
});
//button
this.main.pbu.createButton({
    title:this.main.utils.getIf(v.button.t,'SUBSCRIBE'),
    href:v.button.h,
    icon:v.button.ic,
    size:v.button.si,
    align:'center',
    clasz:'sp-subscribe',
    divClasz:['justify-content-center'],
    isView:this.isView,
    cb:processSubscription
}).then(r=>{
    this.main.pbu.appendChild(buttonDiv,r);
});

//
if(this.isView){
if(!v.body){
    body.remove();
}
}else{
attachEvents(null);
}
//finally
return (this.isView && data.parent)?r.el : r.bc;

async function processSubscription(){
      let nameControl = form.querySelector('input.name');
      let emailControl = form.querySelector('input.email');
      let button = form.querySelector('.sp-button');
  //event
     if(!$this.main.vu.validate([nameControl,emailControl])){
        return;
      }
      //
      let subscriber = {
        name:nameControl.value,/**important,to enable binding on backend */
        email: emailControl.value,
        list:'site'
        };
        //
        let r = await $this.main.fu.fetch({
        link:$this.main.fu.getApi('subscribe',[{n:'stage',v:'exist'}]),
        body:JSON.stringify(subscriber),
      });
      if(r=='subscribed'){
            //you ve already subscribed
            $this.main.pbu.addClass(button,['disabled']);
            $this.main.utils.genCookie(true,$this.main.username);
            $this.main.utils.notify('Thank you for subscribing',{level:0});

        }else{
            let modal;
            let authTokenTemplate = $this.main.tu.authToken({cb:async()=>{
            r = await $this.main.fu.fetch({
              link:$this.main.fu.getApi('subscribe',[{n:'stage',v:'save'}]),
              body:JSON.stringify(subscriber)
            });
            if(r=='ok'){
            $this.main.pbu.addClass(button,['disabled']);
            $this.main.utils.genCookie(true,$this.main.username);
            $this.main.utils.notify('Thank you for subscribing',{level:0});
            modal.dismiss.click();
            }
          },tokenUuid:r,withTimer:true,email:emailControl});
          //
          modal = $this.main.utils.setModal('Verify token',authTokenTemplate);
          modal.confirm.remove();
          modal.cancel.remove();
        }
}//inner
/**
 * 
 * @param {boolean|null} save 
 */
async function attachEvents(save){
if(save==null){
}else if(save==false){
return await $this.main.pbu.getDropdown({name:"Align",el:r.el,attr:'al',items:['Left','Center','Right'],defaultValue:'Left'});
}else if(save==true){
    return true;
}

}//inner

}//func

setLink(){
let form = this.main.pbu.createElement('form',['search-post', 'auto-complete','position-relative']);
    form.innerHTML = 
    `
   ${this.main.pbu.createFormControl({serialize:true,type:"url",placeholder:"Link",clasz:['sp-link']})}
    
    `;
    let linkControl = form.querySelector('.sp-link');
    let modal = this.main.utils.setModal('Link',form);
    linkControl.focus();
    this.main.pbu.listen(linkControl,'input',async()=>{
    if(!this.main.vu.sanitize([linkControl])){return;}
    let regex = new RegExp(`${linkControl.value}`, "i");
    let posts = await this.main.fu.fetch({link:this.main.fu.getApi('/home/posts',[{n:'limit',v:-1}])});
    posts = posts.filter(p=>regex.test(p.title));
    this.main.autoComplete(linkControl,false,posts,'post');
  });//


    this.main.pbu.listen(modal.confirm,'click',()=>{
        //validate
    let href = linkControl.value;
    if(!href){return;}
    if(!this.main.vu.validate(linkControl)){return;}
    let a = this.main.pbu.createElement('a');
    a.id = `id${this.main.utils.getRandomInt(100)}`;
    a.href = linkControl.getAttribute('data-path');
    a.textContent = this.selectedText;
    this.selectionRange?.deleteContents();
    this.selectionRange.insertNode(a);
    modal.dismiss.click();
    });
}//func

/**
 * 
 * @param {HTMLButtonElement} formatButton 
 * @returns 
 */
formatText(formatButton){
let name = this.main.pbu.getAttribute(formatButton,'name');
let isLink = name=='spa';
let clasz = this.main.config.FORMAT_CLASZ[name];
/**@type {HTMLElement}*/let parentElement;
let commonAncestorContainer = this.selectionRange.commonAncestorContainer;
let isText = commonAncestorContainer.nodeType === Node.TEXT_NODE;
let fragment = this.selectionRange.cloneContents();
if (isText) {
if(commonAncestorContainer.parentNode.classList.contains('formatable')){
                //here, there is no element in between 
             
            if(isLink){
                this.setLink();
            }else{
                this.selectionRange.deleteContents();
                this.selectionRange.insertNode(this.main.pbu.createElement('span',[clasz],this.selectedText));
            }
             
             return;
    }else{
        //here, there is an element in between  <span> or <a>
        parentElement = commonAncestorContainer.parentNode;
        if(isLink){
            this.selectedText = parentElement?.textContent;
            parentElement.parentElement.replaceChild(this.main.pbu.createText(this.selectedText),parentElement);
        }else{
            
            this.main.pbu.toggleClass(parentElement,clasz);
            if(parentElement.classList.length==0){
                this.selectedText = parentElement?.textContent;
                parentElement.parentElement.replaceChild(this.main.pbu.createText(this.selectedText),parentElement);
            }
        }
            
            return;
    }
}else{
    //commonAncestorContainer = .formatable
        //here, the range is drawn over both formated and unformatted text
        //retrieve existing class and add

            if(isLink){
                let aFragment = fragment.querySelector('a[href]');
                if(aFragment){
                    let aFull = commonAncestorContainer.querySelector(`#${aFragment.id}`);
                    aFull.parentNode.replaceChild(this.main.pbu.createText(aFull.textContent),aFull);
                }
            }else{
                let elements = fragment.querySelectorAll('*');
        let previousClasz = [];
        elements.forEach(el => {
        if (el.className) {
            // Get all classes from className string
            const classList = el.className.split(' ');
            classList.forEach(cls => {
                if (cls.trim()) previousClasz.push(cls.trim());
            });
        }
    });
        this.selectionRange.deleteContents();
        this.selectionRange.insertNode(this.main.pbu.createElement('span',[clasz,...previousClasz],this.selectedText));
            }
        
        
        return;
}
}//func


/**
 * 
 * @param {HTMLElement} el 
 */
async makeEditable(el){
this.main.pbu.addClass(el,['formatable']);//redundant
this.main.pbu.listen(el,'mouseout',()=>{

try{
let selection = document.getSelection();
if(selection){
//let selectedText = selection.toString();
this.selectedText = selection.toString();
//this.selectedText = selectedText ;
let range = selection.getRangeAt(0);//error here
this.selectionRange = range.cloneRange();
}
}catch(error){

}
});
}//func

// ######### MENU ##########
/**
 * 
 * @param {PointerEvent} evt 
 */

/**
 * 
 * @param {HTMLElement} el 
 * @param {string} direction 
 */
moveBlock(el,direction){
let parent,previousSibling,nextSibling,children;
parent = el.parentElement;
if(direction=='up'){
if(el === parent.firstElementChild){return;}
previousSibling = el.previousElementSibling;
parent.insertBefore(el,previousSibling);
}else{
if(el === parent.lastElementChild){return;}
//moving down
nextSibling = el.nextSibling;
parent.insertBefore(nextSibling,el);
}
}//
/**
 * 
 * @param {HTMLElement} bc 
 */
deleteBlock(bc){
bc.remove();
// let spCol = bc.parentElement;
// spCol.removeChild(bc);
}//func

//####### others ######
/**
 * 
 * @param {Node} node 
 * @returns {Node}
 */
getMostInnerElement(node){
let currentElement = node;
while (currentElement && currentElement.firstChild) {
currentElement = currentElement.firstChild ;
}
return currentElement;
}//

}//#class
